/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";
import { ButtonGroup, Button } from "@mui/material";
import KeyboardArrowUpOutlinedIcon from "@mui/icons-material/KeyboardArrowUpOutlined";
import KeyboardArrowDownOutlinedIcon from "@mui/icons-material/KeyboardArrowDownOutlined";

const UpDownButtons = (props) => {
    
    const {
        handleUp,
        handleDown,
        upDisabled = false,
        downDisabled = false
    } = props;
    const ariaLabelUp = upDisabled ? "can not move up" : "move up";
    const ariaLabelDown = downDisabled ? "can not move down" : "move down";
    const buttonStyle = { backgroundColor: "transparent", width: "20px", minWidth: "20px" };
    return (
        <div className='position-buttons' style={{ marginLeft: "8px", maxHeight: "40px" }}>
            <ButtonGroup orientation='vertical'>
                <Button
                    key='up'
                    color='neutral'
                    disabled={upDisabled}
                    onClick={handleUp}
                    aria-label={ariaLabelUp}
                    style={buttonStyle}
                >
                    <KeyboardArrowUpOutlinedIcon sx={{ fontSize: 20 }} />
                </Button>
                <Button
                    key='down'
                    color='neutral'
                    disabled={downDisabled}
                    onClick={handleDown}
                    aria-label={ariaLabelDown}
                    style={buttonStyle}
                >
                    <KeyboardArrowDownOutlinedIcon sx={{ fontSize: 20 }} />
                </Button>
            </ButtonGroup>
        </div>
    );
};

UpDownButtons.displayName = "UpDownButtons";
export { UpDownButtons };
